<template>
    <a class="user-menu-item">
        <div class="icon">
            <i v-if="!isLoading" :class="iconClass"></i>
            <div v-if="isLoading" class="loader"></div>
        </div>
        <slot></slot>
    </a>
</template>

<script setup lang="ts">
    // props
    defineProps<{
        iconClass: string;
        isLoading?: boolean;
    }>();
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../../assets/styles/scss/shared/_mixins.scss";

    .user-menu-item {
        position: relative;
        min-height: 22px;
        display: block;
        text-decoration: none;
        padding: 11px 4px 11px 76px;
        font-size: 16px;
        font-weight: 300;
        color: colors.$fontColor;
        line-height: 22px;

        > .icon {
            position: absolute;
            left: 0;
            top: 0;
            height: 44px;
            text-align: center;
            width: 60px;
            padding-left: 16px;
            box-sizing: border-box;
            line-height: 44px;

            > .fas {
                font-size: 16px;
                line-height: 44px;
            }

            > .loader {
                width: 20px;
                height: 20px;
                margin: 12px;
                background-image: url("/assets/img/app/loading_green.svg");
            }
        }

        &:active {
            background-color: #fafafa;
            color: colors.$green;
        }
    }
</style>
